var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFile48Line = function SvgIconFile48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.52 17.26-.05-.1c-.07-.13-.16-.25-.27-.36l-8-8c-.11-.11-.23-.19-.36-.27-.03-.02-.06-.04-.1-.05-.13-.06-.27-.12-.41-.15-.11-.02-.22-.03-.33-.03H15.6a5.31 5.31 0 0 0-5.3 5.3v20.8c0 2.92 2.38 5.3 5.3 5.3h16.8c2.92 0 5.3-2.38 5.3-5.3V18c0-.26-.07-.51-.18-.74Zm-5.62-.96h-2.2v-2.2l2.2 2.2Zm.5 20H15.6a1.9 1.9 0 0 1-1.9-1.9V13.6c0-1.05.85-1.9 1.9-1.9h10.7v5.1c0 1.6 1.3 2.9 2.9 2.9h5.1v14.7a1.9 1.9 0 0 1-1.9 1.9Z",
    fill: "current"
  })));
};
export default SvgIconFile48Line;